import { useHeaderStyles } from "./styles";
import { Box, Typography } from "@material-ui/core";

const Header = ({ title, activityType, style }) => {
  const styles = useHeaderStyles();

  return (
    <Box className={styles.container} style={style}>
      <Typography className={styles.title}>{title}</Typography>
      {activityType && (
        <Typography className={styles.activityType}>{activityType}</Typography>
      )}
    </Box>
  );
};

export default Header;
